export default {
    closeButton: "Schließen",
    helpLabel: "Hilfe",
    homeLabel: "Home",
    logoutButton: "Abmelden",
    notificationsLabel: "Nachrichten",
    noUserDataLabel: "Keine Daten vorhanden",
    settingsLabel: "Einstellungen",
    userLabel: "Nutzer",
    userProfileLinkText: "Nutzer Profil"
};
